import { ButtonProps } from '@mui/material';
import { UseFormReturn } from 'react-hook-form'
import { IOtapAgentForm } from '../../models'

export enum MaxConcurrentType {
  H = 'H',
  M = 'M',
  L = 'L',
}

export function toMaxConcurrentType(value: string): MaxConcurrentType {
  const normalized = value.toUpperCase();
  return Object.values(MaxConcurrentType).includes(normalized as MaxConcurrentType)
    ? (value as MaxConcurrentType)
    : MaxConcurrentType.L;
}

export interface TimeSchedule {
  day: string,
  hour: number,
  concurrentType: string,
  maxConcurrentTypeInfo: Record<
    MaxConcurrentType,
    {
      color: ButtonProps['color'];
      title: string;
      value: number;
    }
  >;
  handler: (hour: number, concurrentType: string) => void;
}

export interface DaySchedules {
  day: string
  maxScheduleHoursLength: number
  methods: UseFormReturn<IOtapAgentForm, any>,
  formPath: any,
  maxConcurrentTypeInfo: Record<
    MaxConcurrentType,
    {
      color: ButtonProps['color'];
      title: string;
      value: number;
    }
  >;
}

export interface MaxConcurrentSchedules {
  methods: UseFormReturn<IOtapAgentForm, any>,
  agentNetworkIndex: number
}
